import { Chip } from "@bp/ui-components";

export type StatusKind =
  | "active"
  | "disabled"
  | "invite"
  | "ok"
  | "warn"
  | "err"
  | "info"
  | "neutral";

type Tone = "ok" | "warn" | "err" | "info" | "neutral";

const STATUS: Record<StatusKind, { tone: Tone; label: string }> = {
  active: { tone: "ok", label: "Aktiv" },
  disabled: { tone: "err", label: "Deaktiviert" },
  invite: { tone: "warn", label: "Einladung offen" },
  ok: { tone: "ok", label: "OK" },
  warn: { tone: "warn", label: "Achtung" },
  err: { tone: "err", label: "Problem" },
  info: { tone: "info", label: "Info" },
  neutral: { tone: "neutral", label: "" },
};

const TONE: Record<Tone, { bg: string; fg: string }> = {
  ok: { bg: "var(--color-success-lightest)", fg: "var(--color-success)" },
  warn: { bg: "var(--color-warning-lightest)", fg: "var(--color-warning)" },
  err: { bg: "var(--color-error-lightest)", fg: "var(--color-error)" },
  info: { bg: "var(--color-primary-lighter)", fg: "var(--color-primary-dark)" },
  neutral: { bg: "var(--color-grey-lightest)", fg: "var(--color-grey-dark)" },
};

type StatusBadgeProps = {
  status: StatusKind;
  label?: string;
};

export function StatusBadge({ status, label }: StatusBadgeProps) {
  const meta = STATUS[status];
  const tone = TONE[meta.tone];
  const text = label ?? meta.label;
  return (
    <Chip
      bgColor={tone.bg}
      color={tone.fg}
      // Status labels are short sentences ("Nur über Elternaccount"); never cut them.
      maxWidth="none"
      isSmall
      value={<span style={{ display: "inline-flex", alignItems: "center", gap: 5 }}>{text}</span>}
    />
  );
}
